import {useEffect, useState, type ReactNode} from 'react';
import {ContextoPantallaCompleta} from './pantalla-completa';

// Filtros, tabla y paginacion que se pueden abrir a pantalla completa (solo
// eso: lo que va fuera de la zona, como el mapa, queda tapado). El boton lo
// dibuja la tabla, justo encima de ella; Esc vuelve a la vista normal. La capa
// va por encima del mapa (Leaflet usa capas hasta 1000).
export function ZonaAmpliable({titulo, children}: {titulo: string; children: ReactNode}) {
  const [completa, setCompleta] = useState(false);

  useEffect(() => {
    if (!completa) return;
    const alPulsar = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setCompleta(false);
    };
    window.addEventListener('keydown', alPulsar);
    return () => window.removeEventListener('keydown', alPulsar);
  }, [completa]);

  return (
    <ContextoPantallaCompleta.Provider value={{completa, alternar: () => setCompleta(v => !v)}}>
      <div
        role={completa ? 'dialog' : undefined}
        aria-label={completa ? titulo : undefined}
        className={
          completa ? 'fixed inset-0 z-[1100] flex flex-col gap-3 overflow-auto bg-papel p-4' : 'flex flex-col gap-4'
        }
      >
        {children}
      </div>
    </ContextoPantallaCompleta.Provider>
  );
}
